<template>
  <div class="page3-main">
    <div class="filter-main">
      筛选条件：
      <div class="filter-item">
        <label>h指数：</label>
        <el-select v-model="htIndex" placeholder="请选择" clearable @change="handleHtIndexSearch">
          <el-option v-for="item in htIndexList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <label>被引用次数：</label>
        <el-select v-model="citedCount" placeholder="请选择" clearable @change="handleCitedByCountSearch">
          <el-option v-for="item in citedCountList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <label>作品数量：</label>
        <el-select v-model="paperCount" placeholder="请选择" clearable @change="handleWorksCountSearch">
          <el-option v-for="item in paperCountList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="search_total">
      <p class="total">
        <span>{{ listTotal }}</span
        >条机构数据
      </p>
    </div>
    <subject-list-skeleton v-if="loading" variant="institution" />
    <ul v-else class="right-list">
      <li v-for="(item, index) in listData" :key="index">
        <span class="right_index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
        <div class="right-content">
          <div class="title" v-safe-html="item.name"></div>
          <div class="num">
            <span>
              论文总量：<label>{{ item.paperCount }}</label>
            </span>
            <span>
              引用总数：<label>{{ item.citedCount }}</label>
            </span>
            <span>
              h指数：<label>{{ item.hindex }}</label>
            </span>
          </div>
        </div>
      </li>
    </ul>
    <div class="noData" v-if="total <= 0 && !loading">
      <img src="../../assets/images/noData.png" />
    </div>
    <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
  </div>
</template>

<script>
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";

export default {
  components: { SubjectListSkeleton },
  data() {
    return {
      loading: true,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      listTotal: 0,
      listData: [],
      keyWords: "",

      htIndexList: [
        {
          name: "全部",
          value: "-",
        },
        {
          name: "h指数:<10",
          value: "-9",
        },
        {
          name: "h指数:10-19",
          value: "10-19",
        },
        {
          name: "h指数:20-29",
          value: "20-29",
        },
        {
          name: "h指数:30-39",
          value: "30-39",
        },
        {
          name: "h指数:40-49",
          value: "40-49",
        },
        {
          name: "h指数:50-59",
          value: "50-59",
        },
        {
          name: "h指数:>=60",
          value: "60-",
        },
      ],
      htIndex: "",
      htIndexStart: "",
      htIndexEnd: "",

      citedCountList: [
        {
          name: "被引量大于1000",
          value: "1000-",
        },
        {
          name: "被引量500-1000",
          value: "500-1000",
        },
        {
          name: "被引量100-500",
          value: "100-500",
        },
        {
          name: "被引量50-100",
          value: "50-100",
        },
        {
          name: "被引量10-50",
          value: "10-50",
        },
      ],
      citedCount: "",
      citedCountStart: "",
      citedCountEnd: "",

      paperCountList: [
        {
          name: "作品数量大于100",
          value: "100-",
        },
        {
          name: "作品数量50-100",
          value: "50-100",
        },
        {
          name: "作品数量30-50",
          value: "30-50",
        },
        {
          name: "作品数量10-30",
          value: "10-30",
        },
        {
          name: "作品数量小于10",
          value: "-10",
        },
      ],
      paperCount: "",
      paperCountStart: "",
      paperCountEnd: "",
    };
  },
  props: {
    parentData: {
      type: String,
      default: "",
    },
    parentConceptId: {
      type: String,
      default: "",
    },
  },
  watch: {
    parentData(val) {
      this.pageNo = 1;
      this.keyWords = val;
      this.getListData();
    },
    deep: true,
    immediate: true,
  },
  mounted() {
    this.keyWords = this.parentData;
    this.getListData();
  },
  methods: {
    handleHtIndexSearch(val) {
      this.htIndex = val;
      let _val = this.htIndex.split("-");
      this.htIndexStart = _val[0];
      this.htIndexEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getListData();
    },
    handleCitedByCountSearch(val) {
      this.citedCount = val;
      let _val = this.citedCount.split("-");
      this.citedCountStart = _val[0];
      this.citedCountEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getListData();
    },
    handleWorksCountSearch(val) {
      this.paperCount = val;
      let _val = this.paperCount.split("-");
      this.paperCountStart = _val[0] ? _val[0] : "";
      this.paperCountEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getListData();
    },
    clearSearch() {
      this.influence = "";
      this.htIndex = "";
      this.i10Index = "";
      this.paperCount = "";
      this.paperCountStart = "";
      this.paperCountEnd = "";

      this.citedCountStart = "";
      this.citedCountEnd = "";
      this.citedCount = "";
      this.pageNo = 1;

      this.getListData();
    },
    getListData() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        conceptId: this.parentConceptId,
        htIndexStart: this.htIndexStart,
        htIndexEnd: this.htIndexEnd,
        citedCountStart: this.citedCountStart,
        citedCountEnd: this.citedCountEnd,
        paperCountStart: this.paperCountStart,
        paperCountEnd: this.paperCountEnd,
      };
      this.loading = true;
      this.$http({
        url: "api/v1/concept/institution/list",
        method: "post",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.listData = res.rows;
        this.total = res.total > 10000 ? 10000 : res.total;
        this.listTotal = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getListData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/public.scss";
.page3-main {
  min-height: 240px;
  .search_total {
    display: flex;
    align-items: center;
    .total {
      color: #86909c;
      span {
        color: #ff0000;
        margin-right: 5px;
      }
    }
    .search {
      margin-left: auto;
      width: 400px;
      position: relative;
      display: flex;
      align-items: center;
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      > span {
        background: #2d8cf0;
        height: 40px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .right-list {
    color: #666;
    li {
      display: flex;
      padding: 20px 0;
      border-bottom: 1px dashed #eeeeee;
      .right_index {
        width: 65px;
      }
      .right-content {
        flex: 1;
        .hover {
          cursor: pointer;
          color: #2d8cf0;
          &:hover {
            color: #2d8cf0 !important;
            text-decoration: underline;
          }
        }
      }
    }
    .title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
      &:hover {
        background-image: linear-gradient(to right, #006eb3, #2d8cf0);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        label {
          -webkit-text-fill-color: initial;
        }
      }
    }
    .num {
      margin-bottom: 8px;
      span {
        display: inline-block;
        margin-right: 30px;
        label {
          color: #4e5969;
        }
      }
    }
    p {
      margin-bottom: 8px;
    }
  }
}
</style>
